import styled from 'styled-components/native'
import { View } from 'react-native'
import Typography from 'APP/Converse/Typography'

export const Divider = styled(View)`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.lightGray};
  width: 100%;
`

export const Section = styled(View)`
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

export const OpeningHoursContainer = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const SectionTitle = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin - 4}px;
`

export const OpeningHoursText = styled(Typography)`
  width: 50%;
`

export const WebsiteText = styled(Typography)`
  text-decoration-line: underline;
`
